let Tabs = mc.widgets.Tabs;

class ReleaseNotesView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: "web"
    };
  }

  static open() {
    mc.ui.modal(<ReleaseNotesView/>, { height: "550px" });
  }

  setTab(tab, changed) {
    if (changed) {
      this.setState({ tab });
    }
  }

  render() {
    let { tab } = this.state;

    let opts = [
      {
        value: "web",
        label: "Investigator Portal"
      },
      {
        value: "investigator2",
        label: "Investigator App"
      },
      {
        value: "link",
        label: "Link App"
      },
      {
        value: "sync",
        label: "Sync App"
      }
    ];

    let src = "https://fileshare.mc10inc.com/release_notes/" + tab + "/?t=" + Date.now();

    return (
      <div className="rc-release-notes-view">
        <Tabs
          options={opts}
          value={tab}
          rounded={true}
          onSelect={this.setTab.bind(this)}/>
        <iframe
          src={src}
          width="100%"
          height="440"
          frameborder="0"
          border="0"/>
      </div>
    );
  }
}

module.exports = ReleaseNotesView;